const emphasis = ({ color, opacity = 0.5 }) => ({
  position: 'relative',
  textShadow: '0 0 6px white',
  zIndex: 1,
  '&:after': {
    content: '""',
    backgroundColor: color,
    width: '100%',
    height: '0.33em',
    position: 'absolute',
    left: 0,
    right: 0,
    top: '0.33em',
    zIndex: -1,
    opacity,
  },
});

export default emphasis;
